import EmailTable from './EmailTable'
export default EmailTable
